import UserUtil from "../constants/user"
import { ROUTE_PERMISSIONS } from "../constants/permissions"

export default {
    // 判断是否有权限访问当前路由
    hasPermission(to) {
        const currentUser = UserUtil.getCurrentUser();
        // 登录：允许访问登录/注册/认证页，其他页跳登录
        if (!currentUser) {
            return to.path === '/login' || to.path === '/register' || to.path === '/authV';
        }
        //检查路由权限
        const allowedRoles = ROUTE_PERMISSIONS[to.path];
        // 有权限配置的路由，判断当前用户roleId是否在允许列表中
        // 未配置权限的路由默认允许所有角色访问
        return allowedRoles ? allowedRoles.includes(currentUser.roleId) : true;
    }
};
